import React, { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useLocation, useNavigate } from 'react-router-dom';
import InactivityModal from './InactivityModal';
import { INACTIVITY_TIMEOUT_MINUTES } from '../../config/inactivity';

const InactivityHandler = ({ children }) => {
  const [isIdle, setIsIdle] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isLoginPage = location.pathname === '/login';
  const timeout = INACTIVITY_TIMEOUT_MINUTES * 60 * 1000;

  const handleOnIdle = () => {
    if (!isLoginPage) {
      setIsIdle(true);
    }
  };

  const handleOnActive = () => {
    setIsIdle(false);
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    setIsIdle(false);
    navigate('/login');
  };

  useIdleTimer({
    timeout,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    debounce: 500,
  });

  return (
    <>
      {children}
      {!isLoginPage && <InactivityModal open={isIdle} onLogout={handleLogout} />}
    </>
  );
};

export default InactivityHandler;
